import { EmbeddedMessage, MessageMedium, WhatsApp } from 'constants/messageMediums';
import { CampaignType } from 'modules/domains/campaign';
import {
  BLAST_SECTION_MAPPER,
  BLAST_SUMMARY_SECTION_MAPPER,
  ELIGIBILITY_SECTION_MAPPER,
  ELIGIBILITY_SUMMARY_SECTION_MAPPER,
  ELIGIBILITY_TRIGGERED_SECTION_MAPPER,
  TRIGGERED_SECTION_MAPPER,
  TRIGGERED_SUMMARY_SECTION_MAPPER,
  WHATSAPP_BLAST_SECTION_MAPPER,
  WHATSAPP_TRIGGERED_SECTION_MAPPER,
} from '../constants';

export const getCampaignEditorSections = (
  campaignType: CampaignType,
  messageMedium?: MessageMedium,
) => {
  if (messageMedium === WhatsApp) {
    return campaignType === CampaignType.Blast
      ? WHATSAPP_BLAST_SECTION_MAPPER
      : WHATSAPP_TRIGGERED_SECTION_MAPPER;
  } else if (campaignType === CampaignType.Blast) {
    return BLAST_SECTION_MAPPER;
  } else if (campaignType === CampaignType.Eligibility) {
    return ELIGIBILITY_SECTION_MAPPER;
  } else if (campaignType === CampaignType.WorkflowTriggered && messageMedium === EmbeddedMessage) {
    return ELIGIBILITY_TRIGGERED_SECTION_MAPPER;
  } else {
    return TRIGGERED_SECTION_MAPPER;
  }
};

export const getCampaignSummarySections = (
  campaignType: CampaignType,
  messageMedium: MessageMedium,
) => {
  if (campaignType === CampaignType.Blast) {
    return BLAST_SUMMARY_SECTION_MAPPER[messageMedium];
  } else if (campaignType === CampaignType.Eligibility) {
    return ELIGIBILITY_SUMMARY_SECTION_MAPPER[messageMedium];
  } else {
    return TRIGGERED_SUMMARY_SECTION_MAPPER[messageMedium];
  }
};

export const shouldExcludeConversionsStep = (
  messageMedium: MessageMedium,
  isWhatsAppGAEnabled: boolean,
) => messageMedium === WhatsApp && !isWhatsAppGAEnabled;
